module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAAXNSR0IArs4c6QAAAS5JREFUOBGNkt1RwzAMx2XnEuexxwgsQEcIG5QN0qdej48rG7BBeSlc89JjhS7QjgCLAI/UvsRIBvVaJ3Hsh8hWpN9Jf0msqmpsG1gald48TqffEHlO8yTU8CwAiuxgdsvNZhTD+AfsXN6PXkidpxML9gOTxzGgE8DIWvt2O589IQyAKkgPei9AXOHzXav0uqs1H3A3n5WU7yB0GQL1Ac4gIVAI0IJ0gepEPMjabrFkpwG3QLF8ju2wg6zXWo2uhETsAlC8pI9/SNQmkffo/wOA/TR5tvDj+N0JIQ2oBQzCCpovnNpFaPwtiC+iydXl0B6daeIDWANPo9YeHSF9AO47BHKQIcAQSMQCQiAJDZRYTu8icTJbGr9RWcFiK60L92/1WpUcFGtJo5f1ekLxvynjCHRHe5MPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/fadedGreyXButton.png
// module id = 290
// module chunks = 0